export class CurrentConversationSectionItemChosenItem {
    conversationSectionItemChosenItemId?: number;
    conversationSectionItemId?: number;
    createdById?: number;
    createdByKind?: number;
    createdDate?: Date;
    approved?: boolean;
    itemId: number;
    name: string;
}
